import { render, staticRenderFns } from "./WxStoreGoods.vue?vue&type=template&id=26d65c7b&scoped=true&"
import script from "./WxStoreGoods.vue?vue&type=script&lang=js&"
export * from "./WxStoreGoods.vue?vue&type=script&lang=js&"
import style0 from "./WxStoreGoods.vue?vue&type=style&index=0&id=26d65c7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d65c7b",
  null
  
)

export default component.exports